import React, {useEffect, useMemo,useRef, useState} from 'react';

import getDBTypeIcon from '../../../../utils/getDBTypeIcon';
import styles from './styles/header.module.css';

import ButtonRadius5 from '../../../design-system/button/ButtonRadius5';
import SearchField from '../../../design-system/search-field/SearchField';
import {ReactComponent as PlusIcon} from '../../../../assets/design-system/plus-size-2.svg';

export default function Header({ aliasName, response, responseData, responseCount, error, loading, handleChange, toggleAddModal, validateParams }) {
    const tabRefs = useRef([]);

    const [activeTab, setActiveTab] = useState(null);

    const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });

    const defaultTabMap = [
        { name: '전체', value: null, count: 0, icon: null }
    ];

    const databaseTabMap = [
        { name: '전체', value: null, count: responseCount?.total || 0, icon: null },
        { name: 'MariaDB', value: 'MARIADB', count: responseCount?.MARIADB || 0 },
        { name: 'MSSQL',  value: 'MSSQL',  count: responseCount?.MSSQL || 0 },
        { name: 'MySQL',  value: 'MYSQL',  count: responseCount?.MYSQL || 0 },
        { name: 'Oracle', value: 'ORACLE',  count: responseCount?.ORACLE || 0 },
        { name: 'PostgreSQL', value: 'POSTGRESQL', count: responseCount?.POSTGRESQL || 0 },
        { name: 'SQLite', value: 'SQLITE',  count: responseCount?.SQLITE || 0 }
    ];

    const getCurrentTabMap = () => {
        // 처음 로딩인 경우
        if (loading && !response) {
            return defaultTabMap;
        }

        // 에러가 발생한 경우
        if (!loading && error) {
            return defaultTabMap;
        }
        
        // 등록된 DB가 없는 경우
        if (responseData?.length === 0 && !validateParams()) {
            return defaultTabMap;
        }
        
        // 그 외의 경우
        return databaseTabMap;
    };

    const currentTabMap = useMemo(() => getCurrentTabMap(), [
        loading,
        response,
        responseData,
        responseCount,
        error,
        responseData,
        validateParams
    ]);

    const dbIconStyle = { width: '20px', height: '20px' };

    const clickTab = (value) => {
        setActiveTab(value);
        handleChange({
            target: {
                name: 'dbType',
                value
            }
        });
    };

    useEffect(() => {
        const index = currentTabMap.findIndex(tab => tab.value === activeTab);

        const el = tabRefs.current[index];

        if (el) {
            const { offsetLeft, offsetWidth } = el;
            setIndicatorStyle({ left: offsetLeft, width: offsetWidth });
        }
    }, [activeTab, currentTabMap]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.searchField}> {/* 남는 공간을 모두 차지하게 하기 위해 div로 감쌈 */}
                    <SearchField
                        height='H50'
                        placeholder='별칭을 검색해 보세요'
                        name='aliasName'
                        value={aliasName}
                        handleChange={handleChange}
                    />
                </div>
                <ButtonRadius5
                    width='160px'
                    height='H50'
                    status='active'
                    icon={<PlusIcon />}
                    text='DB 추가'
                    handleClick={toggleAddModal}
                />
            </div>
            <div className={styles.containerTab}>
                {currentTabMap.map(({ name, value, count }, index) => (
                    <button
                        key={value ?? 'all'}
                        ref={el => tabRefs.current[index] = el}
                        className={styles.tab}
                        data-type={value === activeTab ? 'active' : ''}
                        onClick={() => clickTab(value)}
                    >
                        {getDBTypeIcon(value, dbIconStyle)}
                        <p>{name}({count})</p>
                    </button>
                ))}
                <div className={styles.indicator} data-loading={loading ? 'true' : ''} style={indicatorStyle} />
            </div>
        </div>
    );
}
